<template>
  <div class="space-y-6 col-span-1">
    <div class="-mr-4 bg-white col-span-1 overflow-hidden shadow rounded-lg divide-y divide-gray-200 w-full">
      <div class="px-4 py-3 sm:px-4">
        <div class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div class="ml-4 mt-2">
            <nav class="flex ml-2" aria-label="Breadcrumb">
              <h3 class="text-base items-center leading-6 font-medium text-gray-900 pr-2">
                {{ $t('message.reports.plan') }} :
              </h3>
              <ol role="list" class="flex items-center space-x-4">
                <li v-if="currentDevice.plant !== undefined">
                  <div class="flex items-center">
                    <p href="#" class="mr-3 text-sm font-medium text-gray-500 hover:text-gray-700">{{currentDevice.plant}}</p>
                    <svg v-if="currentDevice.plant !== undefined" class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                  </div>

                </li>

                <li v-if="currentDevice.line !== undefined">
                  <div class="flex items-center">
                    <!-- Heroicon name: solid/chevron-right -->
                    <p href="#" class="mr-3 text-sm font-medium text-gray-500 hover:text-gray-700">{{currentDevice.line}}</p>
                    <svg v-if="currentDevice.line !== undefined" class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                  </div>
                </li>

                <li>
                  <div class="flex items-center">
                    <!-- Heroicon name: solid/chevron-right -->
                    <p class="text-sm font-medium text-gray-500 hover:text-gray-700" aria-current="page">{{currentDevice.name}}</p>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div class="px-4 py-6">
          <div class="grid grid-cols-5 gap">
            <div class="col-span-5 sm:col-span-3">
              <vue-apex-charts type="donut" height="250" :options="chartOptionDonut" :series="seriesDonutChart"></vue-apex-charts>
            </div>
            <div class="sm:col-span-2 col-span-5 flex justify-center">
              <table class="table-fixed border-collapse w-full">
                  <tr>
                    <th class="border border-slate-300">Producción</th>
                    <td class="border border-slate-300 text-center">{{dataTable[0]}}</td>
                  </tr>
                  <tr>
                    <th class="border border-slate-300">Planificado a la fecha</th>
                    <td class="border border-slate-300 text-center">{{dataTable[1]}}</td>
                  </tr>
                  <tr>
                    <th class="border border-slate-300">Planificado para periodo</th>
                    <td class="border border-slate-300 text-center">{{dataTable[2]}}</td>
                  </tr>
              </table>
            </div>
          </div>
          <vue-apex-charts type="area" height="250" :options="chartOptionsArea" :series="seriesArea"></vue-apex-charts>
          <vue-apex-charts type="bar" height="250" :options="chartOptionsBarStacked" :series="seriesBarStacked"></vue-apex-charts>
      </div>

    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { getUnixTime } from 'date-fns'
import { mapGetters } from 'vuex'
//import dayjs from 'dayjs'
export default {
  name: 'report-plan',
  components: { VueApexCharts },
  mounted() {
    this.fetchData()
  },
  props: {
    range: {
      type: Object,
      required: true
    },
    currentDevice: {
      type: Object,
      required: true
    },
    reportnav: {
      type: Object
    }
  },
  watch: {
    range() {
      this.fetchData()
    },
    currentDevice() {
      this.fetchData()
    },
    devid(newValue, oldValue) {
      if(newValue !== oldValue){
        this.series = []
        this.seriesLine = []
        console.log('watch prod.chart -> devid')
        this.fetchCounts()
        this.$forceUpdate()
      }
    },
    start(newValue, oldValue) {
      if(newValue !== oldValue){
        console.log('start')
        this.fetchData()
      }
    },
    end(newValue, oldValue) {
      if(newValue !== oldValue){
        console.log('end')
        this.fetchData()
      }
    }
  },
  methods: {
    async fetchData() {
      // insert code here
      const response_prod = await this.$http.get(`/reports?report=production&devid=${this.currentDevice.devid}&start=${this.start}&end=${this.end}`)
      const response_plan = await this.$http.get(`/reports?report=plan&devid=${this.currentDevice.devid}&start=${this.start}&end=${this.end}`)
      const response_dtd = await this.$http.get(`/reports?report=distribution_time_dev&devid=${this.currentDevice.devid}&start=${this.start}&end=${this.end}&include_prod=1`)
      console.log("response_dtd ", response_dtd);
      this.dataTable = [response_prod.data.sum_y, response_plan.data.sum_y_to_now, response_plan.data.sum_y]
      this.seriesDonutChart = this.getDataDonutChart(response_plan.data.sum_y_to_now, response_plan.data.sum_y ,response_prod.data.sum_y)
      this.seriesArea = [
        {name: response_prod.data.name, data: response_prod.data.x_y},
        {name: response_plan.data.name, data: response_plan.data.x_y}
      ]
      this.seriesBarStacked = response_dtd.data.map((value)=>{
        return {
          name: value.name,
          data: [value.time],
          unit: value.unit
        }
      })

    },
    getDataDonutChart(planToNow, planTotal, prod){
      // console.log("getDataDonutChart", planToNow, planTotal, prod);
      if (prod>planTotal){
        return [prod, 0, 0]
      }
      else if (prod >= planToNow && prod <= planTotal){
        let prodChart = prod
        let planTotalChart = planTotal - prod
        return [prodChart, 0, planTotalChart]
      }
      else if (prod < planToNow) {
        let prodChart = prod
        let planChart =planToNow - prod
        let planTotalChart = planTotal - planToNow
        return [prodChart, planChart, planTotalChart]
      }
    },
  },
  computed: {
    ...mapGetters(['innerStart', 'innerEnd']),
    start() {
      return getUnixTime(this.innerStart)
    },
    end() {
      return getUnixTime(this.innerEnd)
    }
  },
  data() {
    return {
      chart: 'plan',
      report: 'donut',
      params: {},
      validationmodal: false,
      headers: [],
      rows: [],
      downloading: false,
      dataTable: [],
      // Donut chart
      seriesDonutChart: [],
      chartOptionDonut:{
        chart: {
          type: 'donut',
        },
        title: {
          text: 'Avance producción v/s Planificado a la fecha',
          align: 'left',
          style: {
            fontSize: '14px'
          }
        },
        labels:["Producción", "Planificado a la fecha", "Planificado para periodo"],
        colors: ["#68D138", "#DB4437", "#d0d0d0"],
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 90,
          },
        },
      },
      // Area chart
      seriesArea: [],
      chartOptionsArea: {
        title: {
          text: 'Histórico: Producción v/s Planificado',
          align: 'left',
          style: {
            fontSize: '14px'
          }
        },
        annotations: {
          xaxis: [{
            x: new Date(Date.now()).getTime(),
            borderColor: '#f00',
            strokeDashArray: 0,
            yAxisIndex: 0,
            label: {
              show: true,
              text: 'Hoy',
              style: {
                color: "#fff",
                background: '#f00'
              }
            }
          }]
        },
        xaxis: {
          type: 'datetime'
        },
        stroke: {
            curve: 'smooth'
          },
        dataLabels: {
          enabled: false
        },
        // tooltip: {
        //   enabled: true,
        //   custom: ({series, seriesIndex, dataPointIndex, w}) => {
        //
        //     console.log("series: ", series);
        //     console.log("seriesIndex: ", seriesIndex);
        //     console.log("dataPointIndex: ", dataPointIndex);
        //     console.log("w: ", w);
        //     // let dt = w.globals.seriesX[seriesIndex][dataPointIndex]
        //     // const dtf = dayjs(dt).format('DD/MM/YYYY HH:mm:ss')
        //     // const val = series[seriesIndex][dataPointIndex]
        //     // const prod = this.series[seriesIndex].data[dataPointIndex].p
        //     // const lote = this.series[seriesIndex].data[dataPointIndex].l
        //     // const vnom = this.series[seriesIndex].data[dataPointIndex].vnom
        //     return '<div class="p-1 text-xs">' +
        //       `<p><b>${1}</b> / V: ${2} / Vnom: ${3}</p>
        //        ${4} - ${5}
        //       </div>`
        //   },
        // }
      },
      // Bar chart
      seriesBarStacked: [],
      chartOptionsBarStacked: {
        title: {
          text: 'Distribución tiempo máquina a la fecha',
          align: 'left',
          style: {
            fontSize: '14px'
          }
        },
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%'
        },
        xaxis: {
          categories: ["   "],
        },
        colors: ["#68D138", "#DB4437","#F46036", "#775DD0", "#546E7A", "#253A92","#FEB019"],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: false
          },
          y: {
            formatter: (y, config) => {
              if (this.seriesBarStacked == []){
                return ''
              }
              let unit = this.seriesBarStacked[config.seriesIndex].unit
              if (unit === 'minutes'){
                return `${y} minuto${y==1?'':'s'}`;
              }
              else if (unit==='hours') {
                return `${Number((y/60).toFixed(2))} hora${y==1?'':'s'}`;
              }
              else if (unit==='mix'){
                let hours = Math.floor(y / 60)
                let minutes = y % 60
                const result = `${hours>0?`${hours} hora${hours==1?'':'s'}`:''} ${minutes>0?`${minutes} minuto${minutes==1?'':'s'}`:''}`
                return result
              }
              return ''
            }
          }
        }
      },
    }
  }
}
</script>
